module.exports = __webpack_public_path__ + "static/img/content_img1.4256228.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/content_img1.svg
// module id = is1M
// module chunks = 0